export default __webpack_public_path__ + "static/media/element_42.81f80f28.webp";